export default __webpack_public_path__ + "d3a9a32285405728bdcedcc1115dd20e.png";